import React from "react";
import { cn } from "@/components/common/utils";

interface CarouselLeftGradientProps {
  isVisible: boolean;
  className?: string;
  color?: string;
}

export default function CarouselLeftGradient({
  isVisible,
  className,
  color = "#ffffff",
}: CarouselLeftGradientProps) {
  return (
    <div
      className={cn(
        "h-full w-[50px] md:w-[100px] z-10 absolute left-0 transition-opacity duration-500",
        isVisible ? "opacity-100" : "opacity-0",
        className
      )}
      style={{
        backgroundImage: `linear-gradient(to right, ${color}, transparent)`,
      }}
    />
  );
}
